export default "__VITE_ASSET__CNdylp71__"